// Иконка гаечного ключа — категория «Сервис недоступен».
import React from "react";

export function WrenchIcon({ size = 24, color = "currentColor" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
         stroke={color} strokeWidth="1.8"
         strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.5 6.5a3.5 3.5 0 1 0 3.5 3.5l3 3-3 3-3-3a3.5 3.5 0 0 0-3.5-3.5" />
      <path d="M10 13l-6 6 2.5 2.5 6-6" />
    </svg>
  );
}

export default WrenchIcon;
